import type { Filter } from '@cubejs-client/core'
import { CubeOperator } from 'cube/components'
import {
  CHAT_IMPRESSIONS_MEASURES,
  CONVERSATION_FACTS_MEASURES,
  DRIFT_CHAT_OPPORTUNITY_OVERVIEW,
  DRIFT_CHAT_PLAYBOOK_DIMENSIONS,
  DRIFT_CHAT_SKILL_EXECUTIONS_DIMENSIONS,
  ROUTING_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

const initialFilters: Filter[] = [
  {
    member: DRIFT_CHAT_SKILL_EXECUTIONS_DIMENSIONS.SKILL_TYPE,
    operator: CubeOperator.EQUALS,
    values: ['GEN_AI'],
  },
]

export const AIPlaybooksSendsCountQuery: CubeQuery = {
  name: 'AIPlaybooksSendsCount',
  query: {
    measures: [CHAT_IMPRESSIONS_MEASURES.CHAT_IMPRESSIONS_BY_MINUTES_COUNT],
    filters: [
      {
        member: DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_IS_GPT_ENABLED,
        operator: CubeOperator.EQUALS,
        values: ['true'],
      },
    ],
  },
}

export const AIKpiCountsQuery: CubeQuery = {
  name: 'AIKpiCounts',
  query: {
    measures: [
      CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT,
      CONVERSATION_FACTS_MEASURES.EMAIL_CAPTURED_COUNT,
      CONVERSATION_FACTS_MEASURES.MEETINGS_BOOKED_COUNT,
      ROUTING_MEASURES.ROUTING_COUNT,
    ],
    filters: [...initialFilters],
  },
}

export const ConversationFunnelQuery: CubeQuery = {
  name: 'ConversationFunnelCount',
  query: {
    measures: [
      CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT,
      CONVERSATION_FACTS_MEASURES.EMAIL_CAPTURED_COUNT,
      CONVERSATION_FACTS_MEASURES.MEETINGS_BOOKED_COUNT,
      ROUTING_MEASURES.ROUTING_COUNT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.COUNT_INFLUENCED,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.COUNT_SOURCED,
    ],
    filters: [...initialFilters],
  },
}
